import React, { useCallback, useState } from 'react';

import { Button, Col, Row, Select } from 'antd';

interface IProps {
  handleChangeAccount: any;
  accountDefault: any;
  listAccounts: any;
  toggleChangeAccount: any;
}

const AccountList = ({ handleChangeAccount, accountDefault, listAccounts, toggleChangeAccount }: IProps) => {
  const [selectedAccount, setSelectedAccount] = useState<any>(accountDefault);

  const onChangeAccount = useCallback((value: string) => {
    setSelectedAccount(JSON.parse(value));
  }, []);

  const confirmChangeAccount = useCallback(() => {
    handleChangeAccount(selectedAccount);
  }, [handleChangeAccount, selectedAccount]);

  return (
    <Row gutter={0} className='transacation-list__accounts'>
      <Col span={24}>
        <h2>Alteração de conta bancária.</h2>
      </Col>

      <Col span={24}>
        <div>
          <label htmlFor='account' className='mb-1 block text-sm text-gray-600'>
            Selecione a conta que deseja transferir:
          </label>
          <Select
            id='account'
            className='w-full'
            value={JSON.stringify(selectedAccount)}
            onChange={onChangeAccount}
            options={
              listAccounts && !listAccounts.isFetching && listAccounts.length > 0
                ? listAccounts.map((account: any) => ({
                    value: JSON.stringify(account),
                    label: `Banco: ${account.bank_id}, Ag: ${account.agency}-${account.agency_digit}, Conta: ${account.account}-${account.account_digit}, ${account.type}`,
                    key: 'acc-' + account.id
                  }))
                : []
            }
          />
        </div>

        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
          <Button onClick={toggleChangeAccount}>Voltar</Button>

          <Button onClick={confirmChangeAccount} disabled={selectedAccount === accountDefault}>
            Alterar conta
          </Button>
        </div>
      </Col>
    </Row>
  );
};

export default AccountList;
